import React, {useEffect, useState, useRef} from 'react';
import {connect} from 'react-redux';
import {useDispatch} from 'react-redux';
import SelectedSong from '../../Components/SelectedSong/SelectedSong';
import {
  setIsAssignToContactFlow,
  addContact,
  showToast,
  getGallery,
  setSelectedSong,
  setPopUp,
  PopUpEnum,
  setIsGalleryMode,
  setDefaultSong,
  getSubscribersData,
  saveToHistory,
} from '../../FuntoneSlice';
import FuntoneButton from '../../Components/FuntoneButton/FuntoneButton';
import SelectList from 'app/Components/Shared/SelectList/SelectList';
import AddContact from '../../Components/AddContact/AddContact';
import {useScreenNavigation} from '../../Utils/ScreenNavigationUtils';
import {
  dwhFuntoneAssignSongToContact,
  dwhFuntoneAssignSongToContactSuccess,
  dwhFuntoneAssignSongToContactFailed,
} from '../../Reports/dwhReports';
import {getCommonReportParams} from '../../Reports/reportHelpers';

const SongSettings = (props) => {
  const dispatch = useDispatch();
  const {navigateToAdminPanel, navigateToSongs} = useScreenNavigation();
  const {selectedSong, isAssignToContactFlow, isChangeDefaultSongFlow, selectedSubscriber} = props.funtoneSlice;
  const [selectedOption, setSelectedOption] = useState(null);
  const [contacts, setContacts] = useState([{id: 1, value: '', hasError: false, errorMessage: '', profileId: null}]);
  const nextIdRef = useRef(2);


  const optionEnums = {
    DEFAULT_SONG: 'DEFAULT_SONG',
    ADD_TO_PLAYLIST: 'ADD_TO_PLAYLIST',
    CUSTOM: 'CUSTOM',
    DECIDE_LATER: 'DECIDE_LATER',
  };

  const options = [
    {key: 'כולם, חוץ ממי שהגדרתי', value: optionEnums.DEFAULT_SONG},
    {key: 'רוצה להתאים אישית', value: optionEnums.CUSTOM},
    {key: 'אחליט אחר כך', value: optionEnums.DECIDE_LATER},
  ];

  // Helper: Normalize profiles array
  const normalizeProfiles = (profiles) => {
    if (!profiles) return [];
    return Array.isArray(profiles.profile) ? profiles.profile : profiles.profile ? [profiles.profile] : [];
  };

  // Helper: Load contacts from profiles
  const loadContactsFromProfiles = (profilesArray) => {
    if (profilesArray.length === 0) {
      // Reset to empty contact when no profiles exist
      setContacts([{id: 1, value: '', hasError: false, errorMessage: '', profileId: null}]);
      nextIdRef.current = 2;
      return;
    }

    const loadedContacts = profilesArray.map((profile, index) => ({
      id: index + 1,
      value: profile.cli?.callerCli || '',
      hasError: false,
      errorMessage: '',
      profileId: profile.id,
    }));

    const emptyContact = {
      id: loadedContacts.length + 1,
      value: '',
      hasError: false,
      errorMessage: '',
      profileId: null,
    };

    nextIdRef.current = loadedContacts.length + 2;
    setContacts([...loadedContacts, emptyContact]);
  };

  // Helper: Find song in gallery
  const findSongInGallery = (galleryItems, songId) => {
    const galleryArray = Array.isArray(galleryItems) ? galleryItems : [galleryItems];
    return galleryArray.find((s) => {
      const itemId = s.productId || s.id || s.funId;
      return itemId == songId;
    });
  };

  // Load contacts on mount and when profiles change
  useEffect(() => {
    const loadContacts = async () => {
      if (selectedSong && !selectedSong.profiles) {
        const cli = selectedSubscriber?.cli;
        if (cli) {
          const galleryAction = await dispatch(getGallery());
          if (galleryAction.type.endsWith('/fulfilled')) {
            const galleryItems = galleryAction.payload?.results?.subscriberGallery?.items?.item || [];
            const songId = selectedSong?.productId || selectedSong?.id;
            const updatedSong = findSongInGallery(galleryItems, songId);

            if (updatedSong?.profiles) {
              dispatch(setSelectedSong(updatedSong));
            }
          }
        }
      }

      if (selectedSong?.profiles) {
        const profilesArray = normalizeProfiles(selectedSong.profiles);
        loadContactsFromProfiles(profilesArray);
        
        // Determine initial selection based on profiles
        if (profilesArray.length > 0) {
          setSelectedOption(optionEnums.CUSTOM);
        } else if (selectedSong.isDefault) {
          setSelectedOption(optionEnums.DEFAULT_SONG);
        } else {
          setSelectedOption(optionEnums.DECIDE_LATER);
        }
      } else if (isAssignToContactFlow) {
        setSelectedOption(optionEnums.CUSTOM);
      } else if (selectedSong?.isDefault) {
        setSelectedOption(optionEnums.DEFAULT_SONG);
      } else {
        setSelectedOption(optionEnums.DEFAULT_SONG);
      }
    };

    loadContacts();
  }, [selectedSong?.id, selectedSong?.productId, selectedSong?.profiles, selectedSubscriber, dispatch]);

  // Note: isAssignToContactFlow is NOT cleared on unmount
  // It persists between SongsPage and SongSettings
  // It's only cleared when navigating back to admin panel (handled in goBack reducer or handleButtonClick)

  const validatePhoneNumber = (phone) => {
    const cleaned = phone.replace(/\D/g, '');
    if (cleaned.length === 0) return {valid: false, message: 'נא להזין מספר טלפון'};
    if (cleaned.length !== 10) return {valid: false, message: 'מספר טלפון לא תקין'};
    return {valid: true, message: ''};
  };

  const handleContactChange = (id, value) => {
    setContacts((prev) => prev.map((contact) => (contact.id === id ? {...contact, value, hasError: false, errorMessage: ''} : contact)));
  };

  const handleAddContact = async (id, value) => {
    const validation = validatePhoneNumber(value);
    if (!validation.valid) {
      setContacts((prev) => prev.map((c) => (c.id === id ? {...c, hasError: true, errorMessage: validation.message} : c)));
      return;
    }

    const isDuplicate = contacts.some((c) => c.id !== id && c.value.replace(/\D/g, '') === value.replace(/\D/g, ''));
    if (isDuplicate) {
      setContacts((prev) => prev.map((c) => (c.id === id ? {...c, hasError: true, errorMessage: 'מספר זה כבר קיים'} : c)));
      return;
    }

    const cli = typeof selectedSubscriber === 'string' ? selectedSubscriber : selectedSubscriber?.cli;
    const songId = selectedSong?.productId || selectedSong?.id;

    if (!cli || !songId) return;

    // Report assign song to contact initiated
    const reportParams = getCommonReportParams(selectedSubscriber, props.loginData);
    dwhFuntoneAssignSongToContact({
      ...reportParams,
      ban: props.loginData?.userDetails?.ban || '',
      crmId: props.loginData?.userDetails?.crmId || '',
    });

    const addContactAction = await dispatch(addContact({subscriber: cli, songId, phoneNumbers: [value.replace(/\D/g, '')]}));

    if (addContactAction.type.endsWith('/fulfilled')) {
      if (addContactAction.payload?.errorCode === 91) {
        // Report assign song to contact failure
        dwhFuntoneAssignSongToContactFailed({
          ...reportParams,
          ban: props.loginData?.userDetails?.ban || '',
          crmId: props.loginData?.userDetails?.crmId || '',
        });
        setContacts((prev) => prev.map((c) => (c.id === id ? {...c, hasError: true, errorMessage: 'שגיאה בהוספת איש הקשר'} : c)));
        dispatch(showToast('שגיאה בהוספת איש הקשר'));
        return;
      }

      // Report assign song to contact success
      dwhFuntoneAssignSongToContactSuccess({
        ...reportParams,
        ban: props.loginData?.userDetails?.ban || '',
        crmId: props.loginData?.userDetails?.crmId || '',
      });

      const galleryAction = await dispatch(getGallery());
      if (galleryAction.type.endsWith('/fulfilled')) {
        const galleryItems = galleryAction.payload?.results?.subscriberGallery?.items?.item || [];
        const updatedSong = findSongInGallery(galleryItems, songId);

        if (updatedSong) {
          dispatch(setSelectedSong(updatedSong));
          const profilesArray = normalizeProfiles(updatedSong.profiles);
          loadContactsFromProfiles(profilesArray);
        }
      }
    } else {
      // Report assign song to contact failure
      dwhFuntoneAssignSongToContactFailed({
        ...reportParams,
        ban: props.loginData?.userDetails?.ban || '',
        crmId: props.loginData?.userDetails?.crmId || '',
      });
      setContacts((prev) => prev.map((c) => (c.id === id ? {...c, hasError: true, errorMessage: 'שגיאה בהוספת איש הקשר'} : c)));
    }
  };

  const handleRemoveContact = (id) => {
    const contactToRemove = contacts.find((c) => c.id === id);

    if (contactToRemove?.value.trim().length > 0 && contactToRemove.profileId) {
      dispatch(setPopUp({type: PopUpEnum.REMOVE_CONTACT, data: contactToRemove.id}));
    } else if (contacts.length > 1) {
      setContacts((prev) => prev.filter((c) => c.id !== id));
    }
  };

  const handleOptionSelect = async (value) => {
    setSelectedOption(value);
  };

  const handleButtonClick = async () => {
    // If DEFAULT_SONG is selected, set this song as default before navigating
    // Don't call setDefaultSong if we're in assign to contact flow
    if (selectedOption === optionEnums.DEFAULT_SONG && !isAssignToContactFlow) {
      const cli = typeof selectedSubscriber === 'string' ? selectedSubscriber : selectedSubscriber?.cli;
      const songId = selectedSong?.productId || selectedSong?.id;
      
      if (!cli || !songId) {
        dispatch(showToast('שגיאה: לא נבחר מנוי או שיר'));
        return;
      }
      
      const action = await dispatch(setDefaultSong({
        subscriber: cli,
        productId: songId,
      }));
      
      if (!action.type.endsWith('/fulfilled')) {
       return;
      }
    }
    
    if (isAssignToContactFlow) {
      // Clear the assign to contact flow flag and navigate to admin panel
      dispatch(setIsAssignToContactFlow(false));
      navigateToAdminPanel();
    } else {
      navigateToAdminPanel();
    }
  };

  return (
    <div className='song-settings-page'>
      <span className='title'>{props.contentData.songsSettingsTitle.value}</span>
      <SelectedSong title={'השיר שבחרת'} song={selectedSong} />
      {!isAssignToContactFlow && (
        <SelectList options={options} onClick={handleOptionSelect} defaultValue={selectedOption} />
      )}
      {(selectedOption === optionEnums.CUSTOM || isAssignToContactFlow) && (
        <div className='custom-options-container'>
          {!isAssignToContactFlow && (
            <>
              <div className='divider' />
              <span className='custom-options-title'>מי איש הקשר? אפשר גם יותר מאחד</span>
            </>
          )}
          {contacts.map((contact, index) => (
            <AddContact
              key={contact.id}
              value={contact.value}
              placeholder='מספר טלפון של איש קשר'
              hasError={contact.hasError}
              errorMessage={contact.errorMessage}
              isDeleteMode={contact.value.length > 0 && index < contacts.length - 1}
              onCheck={(value) => handleAddContact(contact.id, value)}
              onClear={() => handleRemoveContact(contact.id)}
              onChange={(e) => handleContactChange(contact.id, e.target.value)}
            />
          ))}
        </div>
      )}
      <div className='button-container'>
        <FuntoneButton
          text={isAssignToContactFlow ? 'שמור והמשך' : selectedOption === 'BLACKLIST' ? 'אוקי, בחרתי' : 'בחרתי, אפשר להמשיך'}
          variant='primary'
          onClick={handleButtonClick}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  funtoneSlice: state.FuntoneSlice,
  loginData: state.authentication.loginData,
});

export default connect(mapStateToProps)(SongSettings);
